import { render } from "./sample-data.vue?vue&type=template&id=0d33fdc8"
import script from "./sample-data.vue?vue&type=script&lang=js"
export * from "./sample-data.vue?vue&type=script&lang=js"

import exportComponent from "F:\\fmvic\\Escritorio\\ProyectosDef\\GAB360\\Apps\\Certivin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__